module.exports = __webpack_public_path__ + "static/media/point_icon_03.9d24b106.svg";